import { fetch } from 'wix-fetch';
const options = {
	method: 'GET',
	credentials: 'include',
	cache: 'no-store'
};

export async function getLoggedInUser() {
	let loggedIn;
	const url = `https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails`;
	let results = await fetch(url,options).then(
		async (response) => {
			console.log(response)
			if (response.status !== 200) {
				Promise.reject('Problem in fetching')
			}
			await response.text().then((data) => {
				const values = data
				console.log(values)
				values.indexOf('"success":true') === -1 ? loggedIn = false : loggedIn = true;
				Promise.resolve(loggedIn)
			});
		});
	return loggedIn;
}

export async function getLoggedInUserId() {
	let loggedInUserData;
	const url = `https://www.wix.com/_api/wix-html-login-webapp/user/getUserDetails`;
	let results = await fetch(url).then(
		async (response) => {
			if (response.status !== 200) {
				Promise.reject('Problem in fetching')
			}
			await response.text().then((data) => {
				const values = data;
				values.indexOf('"success":true') === -1 ? loggedInUserData='' : loggedInUserData=data;
				Promise.resolve(loggedInUserData)
			});
		});
		console.log(loggedInUserData,"here")
	return loggedInUserData;
}

// export async function getCountryCode() {
// //AIzaSyCxLwcGY8MVeNKrKd_--7_N4eJVwzKwF7E
// 	let geoData = await wixWindow.getCurrentGeolocation();
// 	console.log(geoData, "hereeeeeeeeee") 
// 	const url = `http://maps.googleapis.com/maps/api/geocode/json?lat=${geoData.coords.latitude}&lng=${geoData.coords.longtude}&sensor=true`;
// 	let results = await fetch(url).then(
// 		async (response) => {
// 			if (response.status !== 200) {
// 				Promise.reject('Problem in fetching')
// 			}
// 			await response.then((data) => {
// 				console.log(data,"hereeeeeeeeee")
// 				Promise.resolve(data)
// 			});
// 		});
// 	// // return loggedInUserData;               // null

// }